import React, { useState } from 'react';
import './../StyleSheets/LeadStageComponent.css';

const LeadStageComponent = () => {
  const stages = ['New', 'Contacted', 'Interested', 'Qualified', 'Won/Lost'];

  const reasons = [
    'General Enquiry',
    'Price Issue',
    'Location Issue',
    'Duplicate Customer',
    'Invalid Number',
    'Not Interested',
    'Timing Issue',
    'No Conversation',
  ];

  const [currentStageIndex, setCurrentStageIndex] = useState(0);
  const [editing, setEditing] = useState(false);
  const [pipelineCompleted, setPipelineCompleted] = useState(false);

  const [stageData, setStageData] = useState({
    New: { registeredAt: new Date().toLocaleString() },
    Contacted: { attempts: 0 },
    Interested: { status: 'Hot' },
    Qualified: { outcome: '', reason: '' },
    'Won/Lost': { completedAt: '', result: '' },
  });

  const updateStageField = (stage, field, value) => {
    setStageData((prev) => ({
      ...prev,
      [stage]: { ...prev[stage], [field]: value },
    }));
  };

  const handleSave = () => {
    const currentStage = stages[currentStageIndex];
    if (currentStage === 'Qualified') {
      const outcome = stageData.Qualified.outcome;
      const dateTime = new Date().toLocaleString();
      if (outcome === 'Customer') {
        updateStageField('Won/Lost', 'completedAt', dateTime);
        updateStageField('Won/Lost', 'result', 'Won');
        setPipelineCompleted(true);
        setEditing(false);
        return;
      } else if (outcome === 'Unqualified') {
        updateStageField('Won/Lost', 'completedAt', dateTime);
        updateStageField('Won/Lost', 'result', 'Lost');
        setPipelineCompleted(true);
        setEditing(false);
        return;
      }
    }
    setEditing(false);
  };

  const handleCancel = () => {
    setEditing(false);
  };

  const moveToNextStage = () => {
    if (currentStageIndex < stages.length - 2) {
      setCurrentStageIndex(currentStageIndex + 1);
      setEditing(false);
    }
  };

  const renderDataBox = (stage, index) => {
    if (index > currentStageIndex) return null;
    const isEditable = editing && index === currentStageIndex;

    switch (stage) {
      case 'New':
        return (
          <div className="data-box">
            <label>Registered At:</label>
            <span>{stageData.New.registeredAt}</span>
          </div>
        );
      case 'Contacted':
        return (
          <div className="data-box">
            <label>No. of Attempts:</label>
            {isEditable ? (
              <input
                type="number"
                min={0}
                value={stageData.Contacted.attempts}
                onChange={(e) => updateStageField('Contacted', 'attempts', e.target.value)}
              />
            ) : (
              <span>{stageData.Contacted.attempts}</span>
            )}
          </div>
        );
      case 'Interested':
        return (
          <div className="data-box">
            <label>Status:</label>
            {isEditable ? (
              <select
                value={stageData.Interested.status}
                onChange={(e) => updateStageField('Interested', 'status', e.target.value)}
              >
                <option value="Hot">Hot</option>
                <option value="Warm">Warm</option>
                <option value="Cold">Cold</option>
              </select>
            ) : (
              <span>{stageData.Interested.status}</span>
            )}
          </div>
        );
      case 'Qualified':
        return (
          <div className="data-box">
            <label>Outcome:</label>
            {isEditable ? (
              <>
                <select
                  value={stageData.Qualified.outcome}
                  onChange={(e) => updateStageField('Qualified', 'outcome', e.target.value)}
                >
                  <option value="">Choose</option>
                  <option value="Customer">Customer</option>
                  <option value="Unqualified">Unqualified</option>
                </select>
                {stageData.Qualified.outcome === 'Unqualified' && (
                  <>
                    <label>Reason:</label>
                    <select
                      value={stageData.Qualified.reason}
                      onChange={(e) => updateStageField('Qualified', 'reason', e.target.value)}
                    >
                      <option value="">Choose</option>
                      {reasons.map((r, i) => (
                        <option key={i} value={r}>
                          {r}
                        </option>
                      ))}
                    </select>
                  </>
                )}
              </>
            ) : (
              <>
                <span>{stageData.Qualified.outcome}</span>
                {stageData.Qualified.outcome === 'Unqualified' && (
                  <span> — {stageData.Qualified.reason}</span>
                )}
              </>
            )}
          </div>
        );
      case 'Won/Lost':
        return stageData['Won/Lost'].completedAt ? (
          <div className={`data-box final-stage ${stageData['Won/Lost'].result === 'Won' ? 'won' : 'lost'}`}>
            <label>{stageData['Won/Lost'].result}:</label>
            <span>{stageData['Won/Lost'].completedAt}</span>
          </div>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className="leadstage-container">
      <h3>Lifecycle Stage</h3>
      <div className="arrow-stage-flow">
        {stages.map((stage, i) => {
          const isCompleted = i < currentStageIndex;
          const isCurrent = i === currentStageIndex;
          const isLast = i === stages.length - 1;

          const wonLostState = stage === 'Won/Lost' && stageData['Won/Lost'].result;

          return (
            <div key={stage} className="stage-group">
              <div
                className={`arrow-stage ${
                  wonLostState
                    ? wonLostState === 'Won'
                      ? 'won' // Apply green style
                      : 'lost' // Apply red style
                    : isCompleted
                    ? 'completed'
                    : isCurrent
                    ? 'current'
                    : 'upcoming'
                } ${isLast ? 'last' : ''}`}
              >
                {wonLostState ? wonLostState : stage}
              </div>
              {renderDataBox(stage, i)}
            </div>
          );
        })}

        {!pipelineCompleted && !editing && (
          <button className="edit-btn" onClick={() => setEditing(true)}>
            Edit
          </button>
        )}

        {editing && (
          <div className="edit-controls">
            <button className="save-btn" onClick={handleSave}>
              Save
            </button>
            {currentStageIndex < stages.length - 2 && (
              <button className="next-btn" onClick={moveToNextStage}>
                Move to Next Stage
              </button>
            )}
            <button className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadStageComponent;
